import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { clientIdGuard } from '../guards/client-id/client-id.guard';

export const onboardingRoutes: Routes = [
  {
    path: 'onboarding',
    canActivate: [authGuard, clientIdGuard],
    loadComponent: () =>
      import('../components/onboarding/onboarding.component').then(
        (m) => m.OnboardingComponent
      ),
    children: [
      {
        path: 'titan-onboarding',
        loadComponent: () =>
      import('../components/onboarding/onboarding-automation-services/onboarding-automation-services.component').then(
            (m) => m.OnboardingAutomationServicesComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'titan-onboarding/create',
        loadComponent: () =>
          import('../components/onboarding/onboarding-automation-services/create-onboarding-automation-services/create-onboarding-automation-services.component').then(
            (m) => m.CreateOnboardingAutomationServicesComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'titan-onboarding/credentials/:sourceId',
        loadComponent: () =>
          import('../components/onboarding/onboarding-automation-services/onboarding-automation-services-update-creds/onboarding-automation-services-update-creds.component').then(
            (m) => m.OnboardingAutomationServicesUpdateCredsComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'fdid-onboarding',
        loadComponent: () =>
          import('../components/onboarding/fdid-onboarding/fdid-onboarding.component').then(
            (m) => m.FdidOnboardingComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },

    ],
  },
];
